import { translationNavigation_da } from "./translationNavigation.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationNavigation_en } from "./translationNavigation.en";

export const translationNavigation = defineBilingualTranslations({
  da: translationNavigation_da,
  en: translationNavigation_en,
});
